import axios from '../../../commons/gdprcontrol-axios'

const state = {
  organization: {
    id: null,
    name: '',
    email: '',
    phone_number: '',
    address_1: '',
    address_2: '',
    city: '',
    zip_code: '',
    country: '',
    dpo: null,
    boss: null
  }
}

const getters = {
  getOrganization: state => state.organization
}

const actions = {
  fetchOrganization: async ({ commit, dispatch }) => {
    return axios.get('/api/organization/')
      .then(response => {
        commit('storeOrganization', response.data)
      })
      .catch(error => {
        alert('Failed to get organization')
        throw error
      })
  }
}

const mutations = {
  storeOrganization: (state, organization) => {
    state.organization = organization
  }
}

export default { state, getters, actions, mutations, namespaced: true }



// WEBPACK FOOTER //
// ./src/store/modules/organizations/details.js